import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ads-manager'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_meta_ads',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    // Old path kept as a redirect so existing links/bookmarks keep working.
    {
      path: frontendURL('accounts/:accountId/settings/meta-ads'),
      redirect: { name: 'settings_meta_ads' },
    },
  ],
};
